import { NgModule } from '@angular/core';
import { TranslatePipe } from '@pipes/translate.pipe';
import { DateFormatDistancePipe, DateFormatPipe } from '@pipes/dateFns.pipe';
import { SortByPipe } from '@pipes/sorts.pipe';
import { getAssetsPath } from '@pipes/getAssetsPath';
import { groupByKeyPipe } from '@pipes/groupByKey.pipe';
import { BalanceFormatPipe, CashoutBalance } from '@pipes/balanceFormat.pipe';
import { getEnv } from '@pipes/getEnv.pipe';
import { getProductName } from '@pipes/getProductName.pipe';
import { WalletControl } from '@pipes/walletControl.pipe';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [
    TranslatePipe,
    DateFormatPipe,
    DateFormatDistancePipe,
    SortByPipe,
    groupByKeyPipe,
    getAssetsPath,
    groupByKeyPipe,
    BalanceFormatPipe,
    getEnv,
    getProductName,
    WalletControl,
    CashoutBalance,
  ],
  providers: [],
  exports: [
    TranslatePipe,
    DateFormatPipe,
    DateFormatDistancePipe,
    SortByPipe,
    groupByKeyPipe,
    getAssetsPath,
    groupByKeyPipe,
    BalanceFormatPipe,
    getEnv,
    getProductName,
    WalletControl,
    CashoutBalance,
  ],
})
export class SharedModule {}
